import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class ToggleList extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'toggle_list_item+',
      group: 'block',
      parseDOM: [],
      toDOM: () => ['ul', { class: 'toggle-list' }, 0],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
